export default function GiftedAlready(): React.ReactElement {
  return (
    <p className="font-poppins text-base">
      {
        "You can share the link again without reducing your remaining 4 articles for this month"
      }
    </p>
  );
}
